import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextEditerPage } from '../../pages/text-editer/text-editer';
import { NavController } from 'ionic-angular';

/**
 * Generated class for the WordSettingComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'word-setting',
  templateUrl: 'word-setting.html',
})
export class WordSettingComponent {
  @Input() autoWords;
  @Input() justDisplay: boolean = false;
  @Input() navCtrl: NavController;

  @Input() postUrl: string;

  @Output() onDirty = new EventEmitter();

  //placeHolder string
  placeHolderStr: string = '暂无内容，点击左侧编辑按钮添加内容';
  constructor() {
    console.log('Hello WordSettingComponent Component');
  }

  editText(obj, index?) {
    //如果不允许编辑，直接return
    if(this.justDisplay) return;

    if (index === undefined) index = '';
    let text = obj['word' + index];
    // this.util.myNav(this.navCtrl.push('GroupPage'));

    this.navCtrl.push(TextEditerPage, {
      text: text,
      onFinished: resultText => {
        obj['word' + index] = resultText;

        //修改后 mark 为 dirty
        this.onDirty.emit();
      },
    });
  }

  onCheckedChange() {
    this.onDirty.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/word-setting/word-setting.ts